import React, { Dispatch } from 'react';
import { createReducer } from 'react-use';
import thunk from 'redux-thunk';

import onboardingReducer, { initialState, OnboardingContextState } from './onboardingReducer';

const useThunkReducer = createReducer<any, OnboardingContextState>(thunk as any);

const OnboardingStateContext = React.createContext<OnboardingContextState>(initialState());
export const OnboardingDispatchContext = React.createContext<Dispatch<any>>(() => {});

interface Props {
  children: React.ReactNode;
}

const OnboardingProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useThunkReducer(onboardingReducer, initialState());
  return (
    <OnboardingStateContext.Provider value={state}>
      <OnboardingDispatchContext.Provider value={dispatch}>{children}</OnboardingDispatchContext.Provider>
    </OnboardingStateContext.Provider>
  );
};

function useOnboardingState() {
  const context = React.useContext(OnboardingStateContext);
  if (context === undefined) {
    throw new Error('useOnboardingState must be used within a OnboardingStateContext');
  }
  return context;
}

function useOnboardingDispatch() {
  const context = React.useContext(OnboardingDispatchContext);
  if (context === undefined) {
    throw new Error('useOnboardingDispatch must be used within a OnboardingDispatchContext');
  }
  return context;
}

export { OnboardingProvider, useOnboardingState, useOnboardingDispatch };
